var actions = {
	next: "Seguinte",
	confirm: "Confirmar",
	"continue": "Continuar"
};
var errors = {
	unknown: "Ocorreu um erro desconhecido",
	contactSupport: "Ocorreu um erro. Contacta o suporte.",
	tryAgain: "Ocorreu um erro. Tenta novamente.",
	submit: "Ocorreu um erro com o teu envio."
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "Iniciar sessão com {name}",
	signupWith: "Inscrever-se com {name}"
};
var alreadyHaveAccount = {
	company: "Já tens uma conta {company}?",
	text: "Já tens uma Streamlabs ID?",
	link: "Iniciar sessão"
};
var noAccount = {
	text: "Ainda não tens uma conta?",
	link: "Inscrever-se"
};
var validation = {
	email: {
		invalid: "Introduz um endereço de e-mail válido"
	},
	password: {
		required: "A palavra-passe é obrigatória",
		min: "A palavra-passe deve ter mais de 8 carateres",
		number: "A palavra-passe deve incluir um número",
		upper: "A palavra-passe deve conter um caráter maiúsculo",
		special: "A palavra-passe deve conter um caráter especial"
	},
	username: {
		invalid: "O nome deve ter pelo menos 5 carateres"
	},
	code: {
		minmax: "O código deve ter entre 6 e 10 carateres"
	}
};
var poweredBy = "Fornecido por <company>Streamlabs</company>";
var card = {
	"404": {
		title: "Empresa não encontrada!",
		desc: "Tenta novamente ou contacta o suporte."
	},
	company: {
		logoAlt: "Logótipo de {company}"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "Código de autenticação de 6 dígitos/código de backup de 8 dígitos",
	successText: "Êxito! A redirecionar...",
	remember: "Memorizar este dispositivo durante 30 dias"
};
var createTfa = {
	scan: {
		title: "Ativa a autenticação de 2 fatores",
		lead: "Clica/copia ou lê o código abaixo para usares a tua aplicação de autenticação preferida. Recomendamos utilizar uma aplicação como <app0 />, <app1 /> ou <app2 /> para guardares os teus códigos em segurança.",
		copied: "Copiado!",
		instructions: "Ou introduz manualmente este código na tua aplicação de autenticação.",
		copy: "Copiar código",
		proceed: "Confirmação"
	},
	confirm: {
		title: "Confirma a tua autenticação de 2 fatores",
		lead: "Envia um código 2FA gerado abaixo para confirmar e ativar a autenticação de 2 fatores.",
		label: "Código de autenticação de 2 fatores (6 dígitos)",
		verify: "Verificar código",
		next: "Êxito! Passo seguinte"
	},
	save: {
		title: "Guarda os teus códigos de recuperação",
		lead: "Guarda os teus códigos de recuperação abaixo para o caso de perderes o acesso à tua aplicação de autenticação de 2 fatores. Após fechares esta janela, estes códigos já não estarão disponíveis.",
		label: "Códigos de recuperação",
		download: "Transferir códigos de recuperação",
		copied: "Códigos copiados!",
		finished: "Concluído"
	}
};
var emailLoginForm = {
	buttonText: "Iniciar sessão",
	emailPlaceholder: "E-mail",
	passwordPlaceholder: "Palavra-passe"
};
var emailSignupForm = {
	buttonText: "Inscrever-se",
	emailPlaceholder: "Configura um e-mail",
	passwordPlaceholder: "Configura uma palavra-passe",
	usernamePlaceholder: "O teu nome",
	ageLabel: "Data de nascimento",
	agePlaceholder: "MM/DD/AAAA",
	agreeText: "Aceito os <terms>Termos de Serviço</terms> e a <privacy>Política de Privacidade</privacy> do Streamlabs.",
	agreeError: "Aceita os termos e condições do Streamlabs"
};
var ageInput = {
	invalidDate: "Introduz uma data de nascimento válida",
	futureDate: "A data de nascimento deve estar no passado",
	minDate: "Não são permitidas datas anteriores ao ano {year}",
	minAge_one: "Tens de ter {years} anos ou mais para utilizar o Streamlabs",
	minAge_two: "Tens de ter {years} anos ou mais para utilizar o Streamlabs",
	minAge_other: "Tens de ter {years} anos ou mais para utilizar o Streamlabs"
};
var forgotPasswordForm = {
	emailPlaceholder: "E-mail",
	back: "Voltar ao Início de sessão",
	successText: "Êxito! Enviámos-te um código de reposição de palavra-passe",
	buttonText: "Pedido de reposição do e-mail",
	create: {
		successText: "Êxito! Enviámos-te um código de verificação para começares!",
		buttonText: "Pedir código de verificação"
	},
	errors: {
		notFound: "Não foi encontrada nenhuma conta com este endereço de e-mail."
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "Esqueceste-te da palavra-passe?",
	lead: "Se necessitares de repor a palavra-passe, introduz o teu e-mail abaixo e vamos enviar um e-mail para iniciar o processo",
	resetTitle: "Repor a palavra-passe",
	resetLead: "Deves ter recebido um código por e-mail. Preenche o formulário para repores a palavra-passe.",
	create: {
		title: "Criar palavra-passe",
		lead: "Parabéns por criares a tua Streamlabs ID! Mais um passo e poderás iniciar sessão integralmente no Streamlabs!",
		resetTitle: "Escolhe uma palavra-passe",
		resetLead: "Deves ter recebido um código por e-mail. Usa-o e preenche o formulário para definires a palavra-passe."
	},
	successText: "Êxito! A redirecionar...",
	signInTitle: "Já tens uma conta?",
	signInBtn: "Iniciar sessão"
};
var checkTfaCard = {
	title: "Verificação da autenticação de 2 fatores",
	lead: "Introduz o código de autenticação de 2 fatores abaixo para continuar.",
	successText: "2FA confirmada com êxito!",
	back: "Voltar"
};
var verifyEmailCard = {
	title: "Verificar e-mail",
	lead: "Consulta o teu e-mail para encontrares o código de 8 dígitos do Streamlabs e insere-o abaixo.",
	back: "Voltar",
	successText: "E-mail verificado com êxito!"
};
var upgradeCard = {
	confirm: {
		title: "Confirmar associação de {company}",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"A partir de agora, podes iniciar sessão no {company} com o endereço de e-mail e a palavra-passe fornecidos.",
			"Podes aceder a todos os produtos do Streamlabs com a tua ID e associar outras contas existentes.",
			"A tua conta {company} não será afetada por esta alteração."
		],
		button: "Confirmar",
		cancel: "Cancelar",
		switchAccount: "Mudar de conta",
		success: "A associar..."
	},
	confirmed: {
		title: "Êxito!",
		subtitle: "A tua Streamlabs ID foi criada e a conta de {company} foi associada.",
		text: "Podes utilizar a tua Streamlabs ID em todos os teus produtos do Streamlabs. Se tiveres outras contas, podes associá-las a esta ID em cada aplicação.",
		button: "Fechar"
	},
	error: {
		user: "Falha ao identificar o utilizador. Tenta iniciar sessão novamente ou contacta o suporte."
	}
};
var confirmCard = {
	confirm: {
		title: "Confirmar associação de {company}",
		subtitle: "Encontrámos uma conta com um e-mail correspondente. Pretendes associar esta conta à Streamlabs ID?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Poderás iniciar sessão no {company} com o endereço de e-mail e a palavra-passe fornecidos para a Streamlabs ID.",
			"Podes aceder a todos os produtos do Streamlabs com a tua ID e associar outras contas existentes.",
			"A tua conta empresarial não será afetada por esta alteração."
		],
		button: "Confirmar",
		cancel: "Cancelar",
		switchAccount: "Mudar de conta",
		success: "A associar..."
	},
	confirmed: {
		title: "Êxito!",
		subtitle: "A tua Streamlabs ID foi criada e a conta de {company} foi associada.",
		text: "Podes utilizar a tua Streamlabs ID em todos os teus produtos do Streamlabs. Se tiveres outras contas, podes associá-las a esta ID em cada aplicação.",
		button: "Fechar"
	},
	error: {
		user: "Falha ao identificar o utilizador. Tenta iniciar sessão novamente ou contacta o suporte."
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " A tua ID já tem uma conta {company} associada",
		subtitle: "Pretendes desassociar a conta associada e associá-la à tua conta Streamlabs atual?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Poderás iniciar sessão no Streamlabs com o endereço de e-mail e a palavra-passe fornecidos para a Streamlabs ID.",
			"Podes aceder a todos os produtos do Streamlabs com a tua ID e associar outras contas existentes.",
			"A tua conta Streamlabs não será afetada por esta alteração."
		],
		button: "Confirmar",
		cancel: "Cancelar",
		switchAccount: "Mudar de conta",
		success: "A associar...",
		agreeLabel: "Compreendo que ao realizar esta associação, perderei o acesso à conta {company} existente que está associada à Streamlabs ID."
	},
	confirmed: {
		title: "Êxito!",
		subtitle: "A tua Streamlabs ID foi criada e a conta de {company} foi associada.",
		text: "Podes utilizar a tua Streamlabs ID em todos os teus produtos do Streamlabs. Se tiveres outras contas, podes associá-las a esta ID em cada aplicação.",
		button: "Fechar"
	},
	error: {
		user: "Falha ao identificar o utilizador. Tenta iniciar sessão novamente ou contacta o suporte."
	}
};
var loginCard = {
	title: "Iniciar sessão",
	lead: "Inicia sessão no <company>{company}</company> com a <id>Streamlabs ID</id>",
	accountExists: "Tudo indica que já tens uma <b>Streamlabs ID</b>. Experimenta iniciar sessão com o teu e-mail.",
	forgotPassword: "Esqueceste-te da palavra-passe?",
	successText: "Êxito! A redirecionar...",
	signInTitle: "Iniciar sessão com uma plataforma"
};
var loginSourcesCard = {
	title: "Iniciar sessão",
	lead: "Iniciar sessão com e-mail/palavra-passe",
	withSlId: "Iniciar sessão com a Streamlabs ID",
	noAccountMessage: "Não encontrámos uma conta associada a este método de início de sessão. Experimenta outro método de início de sessão ou <signup>Inscreve-te</signup> se ainda não o fizeste.",
	accountExistsMessage: "O teu endereço de e-mail da Twitch já está associado ao Streamlabs. Experimenta iniciar sessão com o teu e-mail e palavra-passe do Streamlabs."
};
var resetPasswordForm = {
	emailPlaceholder: "E-mail",
	codePlaceholder: "Código de e-mail de 6-8 dígitos",
	tfaCodePlaceholder: "Código 2FAuthenticator",
	newPasswordPlaceholder: "Nova palavra-passe",
	tfaError: "O código de reposição deve ter entre 6 e 10 carateres",
	next: "Recebeste o código?",
	back: "Voltar para Esqueceste-te da palavra-passe?",
	buttonText: "Alterar palavra-passe",
	successText: "Palavra-passe reposta com êxito",
	create: {
		back: "Voltar ao início",
		buttonText: "Definir palavra-passe",
		successText: "Palavra-passe definida com êxito"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "Palavra-passe atual",
	newPasswordPlaceholder: "Nova palavra-passe",
	newPasswordConfirmationPlaceholder: "Confirmar nova palavra-passe",
	buttonText: "Alterar palavra-passe",
	successText: "Palavra-passe atualizada com êxito",
	newPasswordConfirmationError: "As novas palavras-passe não coincidem",
	back: "Voltar ao painel"
};
var changePasswordCard = {
	title: "Alterar a tua palavra-passe",
	lead: "Introduz abaixo a tua palavra-passe atual e a sua nova palavra-passe.",
	successText: "Palavra-passe atualizada com êxito"
};
var removeTfaForm = {
	tfaCodePlaceholder: "Código de autenticação de 6 dígitos/código de backup de 8 dígitos",
	successText: "2FA removida com êxito",
	removeBtn: "Confirmar e remover"
};
var removeTfaCard = {
	title: "Remover autenticação de 2 fatores",
	lead: "Introduz abaixo o código de confirmação da 2FA para remover a autenticação de dois fatores da tua conta.",
	successText: "2FA removida com êxito",
	back: "Voltar ao painel"
};
var verifyEmailForm = {
	codePlaceholder: "Código de 8 dígitos do e-mail",
	tfaCodePlaceholder: "Código 2FAuthenticator",
	emailPlaceholder: "Endereço de e-mail",
	buttonText: "Verificar e-mail",
	successText: "E-mail verificado com êxito",
	requestBtn: "Pedir novo código",
	requestingBtn: "A pedir...",
	requestSuccess: "Foi enviado um código para o teu e-mail",
	requestAgain: "Pede novamente dentro de {seconds}(s)",
	tfaError: "O código de reposição deve ter entre 6 e 10 carateres",
	back: "Voltar"
};
var signupCard = {
	title: "Inscrever-se",
	lead: "Cria uma conta <id>Streamlabs ID</id> para usar <company>{company}</company>",
	successText: "Êxito! A redirecionar..."
};
var signupSourcesCard = {
	title: "Inscrever-se",
	lead: "Cria uma conta <id>Streamlabs ID</id> para usar <company>{company}</company>",
	withSlId: "Cria uma Streamlabs ID"
};
var connectCard = {
	connect: {
		title: "Escolhe uma conta",
		lead: "para continuar para <b>{company}</b>",
		authorize: "Autorizar",
		authorizeSuccess: "Êxito!",
		cancel: "Cancelar",
		disclaimer: {
			streamlabs: "Se continuares, partilharás a tua Streamlabs ID (nome, endereço de e-mail, preferência de idioma e imagem de perfil) com <b>{company}</b>. Ao autorizares uma conta com <b>{company}</b>, aceitas a <privacy>política de privacidade</privacy> de <b>{company}</b> e os <terms>termos de serviço</terms>.",
			"default": "Para continuares, o Streamlabs vai partilhar o teu nome, endereço de e-mail, preferência de idioma e imagem de perfil com <b>{company}</b>. Ao autorizares uma conta com <b>{company}</b>, aceitas a <privacy>política de privacidade</privacy> de <b>{company}</b> e os <terms>termos de serviço</terms>."
		},
		emailRequired: "É necessária a verificação de e-mail para continuar",
		tfaRequired: "É necessária a autenticação de 2 fatores para continuar"
	},
	login: {
		title: "Inicia sessão no {company}",
		lead: "Deves ter a sessão iniciada para associar as contas",
		loginBtn: "Continuar para início de sessão"
	},
	error: {
		title: "Inicia sessão no {company}",
		lead: "Não foi possível autorizar o teu pedido neste momento.",
		verifyEmail: "Verificar e-mail",
		verify2fa: "Verificar 2FA"
	},
	"switch": {
		btn: "Usar outra conta"
	}
};
var appsDropdown = {
	label: "Produtos e aplicações Streamlabs",
	viewMore: "Expandir",
	viewLess: "Fechar"
};
var platformButtons = {
	loginWithPlatform: "Iniciar sessão com uma plataforma",
	signUpWithPlatform: "Inscrever-se com uma plataforma",
	signUpLead: "Suporte para transmissão em direto para muitas mais plataformas, estas são apenas as opções de inscrição."
};
var ultraCheckoutCard = {
	title: "Melhora as tuas transmissões em direto, marca, edições e muito mais com o <b>Streamlabs Ultra</b>",
	badge: "Inclui <b>{planName}</b>",
	totalValue: "Valor de {price, currency}",
	price: {
		month: "{price, currency}/mês",
		year: "{price, currency}/ano"
	},
	description: {
		month: "Acede a funcionalidades premium em todo o conjunto, incluindo <b>Streamlabs Desktop</b>, <b>Consola</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, e muito mais, disponíveis a um preço único e acessível.",
		year: "Acede a funcionalidades premium em todo o conjunto, incluindo <b>Streamlabs Desktop</b>, <b>Consola</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, e muito mais, disponíveis a um preço único e acessível."
	},
	seeIncluded: "Saber mais",
	buyNow: "Atualizar"
};
var ultraCheckoutBanner = {
	title: "Melhora as tuas transmissões em direto, marca, edições e muito mais com o <b>Streamlabs Ultra</b>",
	badge: "Inclui <b>{planName}</b>",
	totalValue: "Valor de {price, currency}",
	price: {
		month: "{price, currency}/mês",
		year: "{price, currency}/ano"
	},
	description: {
		month: "Acede a funcionalidades premium em todo o conjunto, incluindo <b>Streamlabs Desktop</b>, <b>Consola</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, e muito mais, disponíveis a um preço único e acessível. <link />",
		year: "Acede a funcionalidades premium em todo o conjunto, incluindo <b>Streamlabs Desktop</b>, <b>Consola</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, e muito mais, disponíveis a um preço único e acessível. <link />"
	},
	seeIncluded: "Saber mais",
	buyNow: "Atualizar"
};
var connect = {
	waitMessage: "A combinar dados. Não feches esta janela."
};
var verifyPasswordCard = {
	success: "Palavra-passe verificada com êxito",
	title: "Efetua a reautenticação para verificar",
	lead: "Inicia sessão com o teu e-mail e palavra-passe existentes para continuares a atualizar a tua Streamlabs ID",
	buttonText: "Seguinte"
};
var emailChangeForm = {
	agreeError: "Verifica se compreendes esta ação",
	buttonText: "Seguinte",
	emailPlaceholder: "Novo endereço de e-mail",
	agreeText: "Compreendo que, assim que for verificada, a minha Streamlabs ID será alterada em todos os produtos Streamlabs aos quais está associada."
};
var verifyNewEmailCard = {
	title: "Alterar a tua Streamlabs ID",
	lead: "Fornece um novo e-mail para usar como a tua Streamlabs ID. Enviaremos um código de verificação de 6-8 dígitos para este endereço.",
	successText: "Novo e-mail disponível"
};
var verifyNewEmailOwnershipCard = {
	title: "Verifica a tua Streamlabs ID atualizada",
	lead: "Consulta o teu e-mail para encontrares o código de 8 dígitos do Streamlabs e insere-o abaixo.",
	buttonText: "Confirmar",
	back: "Voltar",
	codePlaceholder: "Código de 8 dígitos do e-mail",
	successText: "Titularidade do e-mail verificada com êxito"
};
var verifyTfaCard = {
	title: "Código de autenticação de 2 fatores",
	lead: "Introduz o código de verificação de 6 dígitos da tua aplicação de autenticação.",
	codePlaceholder: "Código de 6 dígitos",
	buttonText: "Confirmar",
	successText: "Autenticação de 2 fatores confirmada",
	back: "Voltar"
};
var ageGateForm = {
	ageLabel: "Data de nascimento",
	agePlaceholder: "MM/DD/AAAA"
};
var ageGateCard = {
	title: "Concluir a configuração da conta",
	lead: {
		years: "Tens de ter {years} ou mais para criar uma conta. <br />Introduz a tua data de nascimento para concluir a configuração.",
		noYears: "Tens de indicar a tua data de nascimento para criar uma conta. <br />Introduz a data para concluir a configuração."
	},
	successText: "Parabéns! Configuração da conta concluída."
};
var ptPT = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { ptPT as p };
//# sourceMappingURL=pt-PT.es.js.map
